export default __webpack_public_path__ + "static/media/cancel_button.2f0cb573.svg";